import { Components, Theme } from '@mui/material';

import { CalendarIcon } from '@controls/icons/CalendarIcon';
import { getLocalizedDayOfWeek } from '@shared/util/localizationHelper';

type MuiDatePickerTheme = Components<Theme>['MuiDatePicker'];

export const datePickerTheme: MuiDatePickerTheme = {
  defaultProps: {
    dayOfWeekFormatter: getLocalizedDayOfWeek,
    slots: {
      openPickerIcon: CalendarIcon,
    },
    slotProps: {
      field: {
        openPickerButtonPosition: 'start',
      },
    },
  },
};
